import React, { ChangeEvent, ReactNode } from 'react';
import { LinkButton, Counter, Typography } from 'fronton-react';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { getImageSize } from 'pages/common/helpers/get-image-size';
import { ProductArticle } from 'pages/common/components/ProductArticle';
import { SMALL_FALLBACK_PRODUCT_IMAGE_URL } from 'pages/common/consts/urls';
import { ComplimentaryBlockPrice } from './components/ComplimentaryBlockPrice';
import {
  ComplimentaryProductImg,
  ComplimentaryProductInfoTitle,
  CounterWrapper,
  ComplementaryProductInfoWrapper,
  ComplimentaryProductInfoColumn,
  ComplimentaryProductInfoRow,
  ComplimentaryItemLink,
} from './styles';

type TProps = {
  photo?: string;
  displayedName?: string;
  productId?: string;
  count: number;
  price: number | null;
  productPageName?: string;
  isDisabled: boolean;
  onChangeCounter: (_event: ChangeEvent<HTMLInputElement>, value: string) => void;
  variantsComponent?: ReactNode;
  checkboxComponent?: ReactNode;
};

export const ComplementaryProduct = ({
  photo,
  displayedName = '',
  productId,
  count,
  price,
  productPageName,
  isDisabled,
  onChangeCounter,
  variantsComponent,
  checkboxComponent,
}: TProps) => {
  const { mobile } = useBreakpoints() ?? {};

  const imageSize = getImageSize(mobile);

  const hasProductUrl = Boolean(productPageName);

  const handleOpenProduct = () => {
    if (hasProductUrl) {
      window.open(`/product/${productPageName}`);
    }
  };

  const addCount = (_: ChangeEvent<HTMLInputElement>, value: string) => {
    onChangeCounter(_, value);
  };

  return (
    <>
      <ComplimentaryProductInfoTitle>
        {checkboxComponent}
        <ComplimentaryProductImg
          onClick={handleOpenProduct}
          src={photo ?? SMALL_FALLBACK_PRODUCT_IMAGE_URL}
          alt={displayedName}
          loading="lazy"
          width={imageSize}
          height={imageSize}
          data-testid="complimentary-product-image"
        />
        <ComplimentaryProductInfoColumn>
          <ComplimentaryProductInfoRow>
            <ComplementaryProductInfoWrapper>
              <ProductArticle productId={productId} />
              {hasProductUrl ? (
                <LinkButton
                  disabled={isDisabled}
                  className={ComplimentaryItemLink}
                  size="m"
                  target="_blank"
                  href={`/product/${productPageName}`}
                  variant="normal"
                  data-testid="complimentary-product-title">
                  {displayedName}
                </LinkButton>
              ) : (
                <Typography
                  variant="m"
                  size="body_long"
                  color="text-primary"
                  data-testid="complimentary-product-title">
                  {displayedName}
                </Typography>
              )}
            </ComplementaryProductInfoWrapper>

            <ComplimentaryBlockPrice isDisable={isDisabled} counter={count} price={price} />
          </ComplimentaryProductInfoRow>
          <CounterWrapper>
            <Counter min={1} onChange={addCount} value={`${count}`} size="s" disabled={isDisabled} />
          </CounterWrapper>
        </ComplimentaryProductInfoColumn>
      </ComplimentaryProductInfoTitle>
      {variantsComponent}
    </>
  );
};
